// extracted by mini-css-extract-plugin
export var sliderRange = "_mz-2";
export var sliderRoot = "_mz-0";
export var sliderThumb = "_mz-3";
export var sliderTrack = "_mz-1";